
export const MENU_ITEMS = [
  {
    id: 'vertical-page-realtors',
    label: 'Formations4U',
    url: 'https://formationscorp.com/vertical-page-realtors/',
  },
  {
    id: 'calculator',
    label: 'Calculator',
    url: '/calculator',
  },
  {
    id: 'case-studies',
    label: 'Customer Stories',
    url: 'https://formationscorp.com/case-studies/',
  },
  {
    id: 'blog',
    label: 'Blog',
    url: 'https://formationscorp.com/blog/',
  },
  {
    id: 'about-us',
    label: 'About Us',
    url: 'https://formationscorp.com/about-us/',
  },
];
